import { Link } from "react-router-dom";
import { useCallback, useState } from "react";
import { cookieConsentValues, getCookieConsent, setCookieConsent } from "@/utils/cookieConsent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !getCookieConsent());

  const saveConsent = useCallback((value) => {
    setCookieConsent(value);
    setVisible(false);
    window.dispatchEvent(new Event("nossa-cookie-consent-updated"));
    if (value === cookieConsentValues.accepted && typeof window.NOSSA_ENABLE_ANALYTICS === "function") {
      window.NOSSA_ENABLE_ANALYTICS();
      if (typeof window.NOSSA_ENABLE_POSTHOG === "function") {
        window.NOSSA_ENABLE_POSTHOG();
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: `${window.location.pathname}${window.location.search}`,
        });
      }
    }
  }, []);

  if (!visible) return null;

  return (
    <section className="cookie-banner" data-testid="cookie-banner" role="dialog" aria-live="polite" aria-label="Aviso de cookies">
      <div className="cookie-banner-copy">
        <strong data-testid="cookie-banner-title">Usamos cookies</strong>
        <p data-testid="cookie-banner-description">
          Utilizamos cookies técnicas y, si aceptas, cookies analíticas para mejorar la web. Puedes consultar más información en nuestra <Link to="/politica-cookies" data-testid="cookie-banner-policy-link">Política de Cookies</Link>.
        </p>
      </div>
      <div className="cookie-banner-actions" data-testid="cookie-banner-actions">
        <button type="button" className="cookie-button secondary" onClick={() => saveConsent(cookieConsentValues.rejected)} data-testid="cookie-reject-button">Rechazar</button>
        <button type="button" className="cookie-button primary" onClick={() => saveConsent(cookieConsentValues.accepted)} data-testid="cookie-accept-button">Aceptar</button>
      </div>
    </section>
  );
};